import React from 'react';

const MintedLogo = ({ 
  size = 'md', 
  className = '' 
}) => {
  const sizes = {
    sm: { text: 'text-lg', mSize: 'text-xl' },
    md: { text: 'text-2xl', mSize: 'text-3xl' },
    lg: { text: 'text-4xl', mSize: 'text-5xl' },
    xl: { text: 'text-5xl', mSize: 'text-6xl' },
  };
  const config = sizes[size] || sizes.md;

  return (
    <div className={`inline-flex items-baseline ${className}`}>
      <span
        className={`${config.mSize} text-minted-700 leading-none`}
        style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, fontStyle: 'italic' }}
      >
        M
      </span>
      <span className={`font-display font-medium ${config.text} text-stone-900 tracking-[0.08em] leading-none`}>
        inted
      </span>
    </div>
  );
};

export const MintedLogoHorizontal = ({ 
  size = 'md', 
  className = '' 
}) => {
  const sizes = {
    sm: { text: 'text-base', mSize: 'text-xl' },
    md: { text: 'text-xl', mSize: 'text-[28px]' },
    lg: { text: 'text-2xl', mSize: 'text-4xl' },
  };
  const config = sizes[size] || sizes.md;

  return (
    <div className={`inline-flex items-baseline ${className}`}>
      <span
        className={`${config.mSize} text-minted-700 leading-none`}
        style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, fontStyle: 'italic' }}
      >
        M
      </span>
      <span className={`font-display font-medium ${config.text} text-stone-900 tracking-[0.08em] leading-none`}>
        inted
      </span>
    </div>
  );
};

export default MintedLogo;
